/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
export const $AdminUpdateDTO = {
    properties: {
        username: {
            type: 'string',
            isRequired: true,
            maxLength: 320,
            minLength: 3,
        },
        name: {
            type: 'string',
            isRequired: true,
            maxLength: 100,
        },
        email: {
            type: 'string',
            isRequired: true,
            format: 'email',
            maxLength: 320,
            minLength: 7,
        },
        phoneNumber: {
            type: 'string',
            isNullable: true,
        },
        password: {
            type: 'string',
            isNullable: true,
        },
        isActive: {
            type: 'boolean',
        },
        userRoleId: {
            type: 'number',
            isRequired: true,
            format: 'int32',
        },
        forcePasswordReset: {
            type: 'boolean',
        },
    },
};